var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card-compromisso',{attrs:{"hora-inicial":_vm.horaInicial,"hora-final":_vm.horaFinal,"nome-paciente":_vm.nomePaciente,"procedimento":_vm.procedimento,"cor":'#1186D9'}})}
var staticRenderFns = []

export { render, staticRenderFns }